import React, { useState, useEffect } from 'react';
import hamsterIcon from '../assets/images/hamster-svgrepo-com-2.svg';
import './HamsterFloatingButton.css';
import HamsterChatWindow from './HamsterChatWindow';
import notificationService from '../services/notificationService';

const HamsterFloatingButton = ({ hidden = false }) => {
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [hasNewMessage, setHasNewMessage] = useState(false);
    const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);

    const toggleChat = () => {
        setIsChatOpen(!isChatOpen);
        if (hasNewMessage) {
            setHasNewMessage(false);
        }
    };

    // Fetch notification stats for badge count
    useEffect(() => {
        const fetchNotificationStats = async () => {
            try {
                const stats = await notificationService.getStats();
                setUnreadNotificationCount(stats.unread || 0);
            } catch (error) {
                console.error('Error fetching notification stats:', error);
                setUnreadNotificationCount(0);
            }
        };

        fetchNotificationStats();

        // Refresh counts every 30 seconds for better responsiveness
        const intervalId = setInterval(fetchNotificationStats, 30000);

        // Listen for immediate updates when notifications are marked read/unread
        const handleNotificationChange = () => {
            fetchNotificationStats();
        };
        
        window.addEventListener('notificationStatsChanged', handleNotificationChange);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('notificationStatsChanged', handleNotificationChange);
        };
    }, []);

    // Reset notification when chat is opened
    useEffect(() => {
        if (isChatOpen) {
            setHasNewMessage(false);
        }
    }, [isChatOpen]);

    if (hidden) return null;

    return (
        <>
            <button 
                className={`hamster-circle ${isChatOpen ? 'active' : ''} ${hasNewMessage ? 'has-notification' : ''}`}
                onClick={toggleChat}
                aria-label={`Toggle HAMSTER Assistant ${unreadNotificationCount > 0 ? `- ${unreadNotificationCount} unread notifications` : ''}`}
            >
                <img 
                    src={hamsterIcon} 
                    alt="HAMSTER Assistant" 
                    className="hamster-icon"
                />
                {unreadNotificationCount > 0 && (
                    <span className="hamster-notification-badge">{unreadNotificationCount}</span>
                )}
            </button>
            {isChatOpen && (
                <HamsterChatWindow 
                    onClose={() => setIsChatOpen(false)} 
                />
            )}
        </>
    );
};

export default HamsterFloatingButton; 